import * as React from 'react';
import { Card, Text, Icon } from '@amzn/storm-ui';
import { spinner } from '@amzn/storm-ui-icons';
import styled from 'styled-components';
import { AccountType } from './Types';
import { useBundle } from '@amzn/react-arb-tools';

const AccountInfoCardContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.base};
`;

const StyledCard = styled(Card)`
  background: ${({ theme }) => theme.palette.gray[100]};
`;

const PropertyPairContainer = styled.div`
  display: flex;
`;

const PropertyPair = ({ label, value }) => {
  return (
    <PropertyPairContainer>
      <Text fontSize="small" inline textColor="tertiary">
        {`${label}: `}
      </Text>
      <Text fontSize="small" inline>
        {value}
      </Text>
    </PropertyPairContainer>
  );
};

type AccountInfoCardProps = {
  accountName?: string;
  accountType?: AccountType;
  entityId?: string;
};

export const AccountInfoCard: React.VFC<AccountInfoCardProps> = ({
  accountName, accountType, entityId
}) => {
  const [bundle, isBundleLoading] = useBundle('pages.interstitial');

  if (isBundleLoading) {
    return <Icon type={spinner}></Icon>
  }

  const accountTypeLabel = bundle.getMessage('account_type');
  const idLabel = bundle.getMessage('id');

  return (
    <AccountInfoCardContainer>
      <StyledCard padding="small">
        <Text type="h3">{accountName}</Text>
        <PropertyPair
          label={accountTypeLabel}
          value={accountType}
        />
        <PropertyPair
          label={idLabel}
          value={entityId}
        />
      </StyledCard>
    </AccountInfoCardContainer>
  );
};
